import { Component, OnInit } from '@angular/core';
import { SectionBase } from '../../../components/section/section-base';
import { ConfigurationService } from '../../../../core/services/impl/configuration/configuration.service';
import { ResourceService } from '../../../services/resource.service';

@Component({
  selector: 'app-information-section',
  templateUrl: './information-section.component.html',
  styleUrls: ['./information-section.component.scss']
})
export class InformationSectionComponent extends SectionBase implements OnInit {

  constructor(private travelConfiguration: ConfigurationService,
              private resourceService: ResourceService) {
    super();
  }

  ngOnInit() {
    this.initBean();
    this.createConfig();
    this.initControlsChanges();

    this.buildForm();
  }

  initBean() {
  }

  initControlsChanges() {
  }

  createConfig() {
    this.formConfig = {
      formKey: 'INFORMATION_SECTION',
      description: 'INFORMATION_SECTION.description',
      fieldsConfig: []
    }
  }

  get distributorInfo(): string {
    return this.resourceService.buildResourceURL(this.travelConfiguration.uiConfig.resources.distributorInfoPdf);
  }

  get administrationPersonalData(): string {
    return this.resourceService.buildResourceURL(this.travelConfiguration.uiConfig.resources.personalDataAdministratorPdf);
  }
}
